import React, { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";


const DashboardLayout = () => {
  const [isDesktop, setIsDesktop] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsDesktop(window.innerWidth >= 992); // Bootstrap's "lg" breakpoint
    };

    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);
    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  const toggleSidebar = () => {
    // Sidebar removed
  };

  return (
    <div className="">
      <div className="row g-0 flex-nowrap">
        {/* Sidebar Component Removed */}

        {/* Content Area - Will render child routes via Outlet */}
        <div
          className="col py-3 px-4"
          style={{
            height: "100vh",
            overflowY: "auto",
          }}
        >
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default DashboardLayout;
